import React from 'react'
import { CreditApplicationCategory } from '_gql'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import { DataGrid, HeaderToolbar, useTable } from '@divvy-web/skylab.datagridnext'
import ViewControl from '@divvy-web/skylab.viewcontrol'

import styles from './styles.module.scss'

const DataGridHeader = () => {
  const [getClassName] = useNameFormatter('DataGridHeader')

  const { setColumnFilters } = useTable()

  return (
    <DataGrid.Header>
      <HeaderToolbar.Root className={styles[getClassName('')]}>
        <HeaderToolbar.Filters>
          <ViewControl
            defaultValue={CreditApplicationCategory.ALL}
            viewControlItems={[
              {
                label: (
                  <FormattedMessage
                    defaultMessage='Action needed'
                    id='sputnik.DataGridHeader__7zRUAf'
                  />
                ),
                value: CreditApplicationCategory.ACTION_NEEDED,
              },
              {
                label: (
                  <FormattedMessage
                    defaultMessage='In review'
                    id='sputnik.DataGridHeader__OXocSj'
                  />
                ),
                value: CreditApplicationCategory.IN_REVIEW,
              },
              {
                label: (
                  <FormattedMessage
                    defaultMessage='Completed'
                    id='sputnik.DataGridHeader__95stPq'
                  />
                ),
                value: CreditApplicationCategory.COMPLETED,
              },
              {
                label: (
                  <FormattedMessage
                    defaultMessage='All'
                    id='sputnik.DataGridHeader__zQvVDJ'
                  />
                ),
                value: CreditApplicationCategory.ALL,
              },
            ]}
            onValueChange={(value) => {
              setColumnFilters([{ id: 'status', value }])
            }}
          />
        </HeaderToolbar.Filters>
        <DataGrid.FlexSpacer />
        <HeaderToolbar.Search className={styles[getClassName('search')]} />
      </HeaderToolbar.Root>
    </DataGrid.Header>
  )
}

export default DataGridHeader
